// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
import '@/assets/index.less?v=cyx1.2'
Vue.use(iView);

import storage from '@/utils/storage.js';
Vue.prototype.$storage=storage;


Vue.prototype.getTime = function (){
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  var HH = date.getHours();
  var mm = date.getMinutes();
  var ss = date.getSeconds();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  if(ss<=9){
    ss=  '0'+ss;
  }
  if(mm<=9){
    mm=  '0'+mm;
  }
  let currentdate = year + '-' + month + '-' + strDate+" "+HH+':'+mm+':'+ss;
  return currentdate;
}

axios.interceptors.response.use(function(response){
  try {
    if(response.data.code===403||response.data.code==='403'){
      Vue.prototype.$Notice.error({
        title: '异常信息',
        desc: response.data.msg,
        duration: 0
      });
      router.push({path:'/login'});
    }
  }catch (e) {
  }
  // 请求成功处理回调
  return response;
}, function(error){
  console.log(error);
  Vue.prototype.$Notice.error({
    title: '服务器错误或网络异常',
    desc: '请刷新网页或重新登录后重试，如未解决请联系管理员。<br/>错误信息：'+error,
    duration: 0
  });
});


import { Table,TableColumn } from 'element-ui';
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
import 'element-ui/lib/theme-chalk/index.css';

import qs from 'qs';
Vue.prototype.$qs=qs;
import axios from 'axios';
Vue.prototype.$axios=axios;

Vue.config.productionTip = false

const power = [
  {path:'/home/Banners',power:1},
  {path:'/home/Keywords',power:2},
  {path:'/home/Classify',power:3},
  {path:'/apply/Apply',power:14},
  {path:'/ucenter/Userinfo',power:15},
  {path:'/lanka/goumai',power:16},
  {path:'/miaosha/Msgkk',power:19},
  {path:'/miaosha/MsNeixun',power:20},
  {path:'/miaosha/MsApply',power:21},
  {path:'/ziliao/ZiliaoFenlei',power:28},
  {path:'/ziliao/ZiliaoHeji',power:31},
  {path:'/ziliao/ZiliaoFiles',power:35},
  {path:'/ziliao/ZiliaoLingqu',power:40},
  {path:'/power/PowerList',power:43},
  {path:'/power/PowerRole',power:43},
  {path:'/power/User',power:44},
];


router.beforeEach((to, from, next) => {

  if(to.path==='/login'||to.path==='/WebView'||to.path==='/OpenApply'||to.path==='/Jk214'){
    next();
  }else{
    let flag = true;

    //统一验证权限是否可以访问页面
    let pwd = storage.getSession('power');
    for(let i = 0;i<power.length;i++){
      if(to.path===power[i].path&&pwd.indexOf(power[i].power)==-1){
        flag = false;
        break;
      }
    }
    if(!flag){
      router.push({path:'/403'});
    }else{
      let uuid = storage.getSession('uid');
      if(uuid){
        next();
      }else{
        router.push({path:'/login'});
      }
    }

  }
});

import store from '@/utils/store.js'; //全局状态管理

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js